/* eslint-disable */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';
(pdfMake as any).vfs = (pdfFonts as any).vfs;

export interface IListagemContasReceber {
  idrec: string;
  emissao: Date;
  vencimento: Date;
  numero: string;
  venda: number;
  vrecebido: number;
  desconto: number;
  acrescimo: number;
  parceiros: string;
  vparcela: number;
  marcado: boolean;
  logo: string;
  vreceber: number;
}
async function PDFReceber(
  dados: IListagemContasReceber[],
  total: number,
  nome: string
) {
  const Tpagar = dados.reduce((acc, item) => acc + item.vreceber, 0);
  const Tdesconto = dados.reduce((acc, item) => acc + item.desconto, 0);
  const Tpago = dados.reduce((acc, item) => acc + item.vrecebido, 0);
  const logo = dados?.[0]?.logo ?? '';
  const parceiro = dados?.[0]?.parceiros ?? ''; 
  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject('Erro canvas');

        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);

        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = () => reject('Erro ao carregar logo');
      img.src = url;
    });
  }
  function gerarLogoPadrao(): string {
    const canvas = document.createElement('canvas');
    canvas.width = 320;
    canvas.height = 90;

    const ctx = canvas.getContext('2d');
    if (!ctx) return '';
    const gradient = ctx.createLinearGradient(0, 0, 320, 0);
    gradient.addColorStop(0, '#1f2937');
    gradient.addColorStop(1, '#374151');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.beginPath();
    ctx.arc(45, 45, 25, 0, 2 * Math.PI);
    ctx.fillStyle = '#10b981';
    ctx.fill();
    ctx.fillStyle = '#ffffff';
    ctx.font = 'bold 20px Arial';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'middle';
    ctx.fillText('CONTAS A RECEBER', 90, 45);

    return canvas.toDataURL('image/png');
  }

  let imageData: string;
  if (logo && logo.trim() !== '') {
    const baseUrl = (window as any).env?.REACT_APP_URL_IMGLOG || '';
    const imageUrl = baseUrl + logo;
    try {
      imageData = await getBase64ImageFromUrl(imageUrl);
    } catch {
      imageData = gerarLogoPadrao();
    }
  } else {
    imageData = gerarLogoPadrao();
  }

  const documentDefinition: any = {
    pageSize: 'A4',
    pageMargins: [40, 40, 40, 60],

    footer: function (currentPage: number, pageCount: number) {
      return {
        stack: [
          {
            canvas: [
              {
                type: 'line',
                x1: 40,
                y1: 0,
                x2: 555,
                y2: 0,
                lineWidth: 0.5,
                lineColor: '#e5e7eb'
              }
            ]
          },
          {
            text: `Página ${currentPage} de ${pageCount}`,
            alignment: 'center',
            fontSize: 8,
            margin: [0, 5, 0, 0],
            color: '#6b7280'
          }
        ]
      };
    },

    styles: {
      titulo: {
        fontSize: 18,
        bold: true,
        alignment: 'center'
      },
      subInfo: {
        fontSize: 10
      },
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'white',
        fillColor: '#1f2937',
        alignment: 'center'
      },
      tableCell: {
        fontSize: 9
      },
      totalValue: {
        bold: true,
        alignment: 'right',
        fillColor: '#e5e7eb'
      },
      totalFinal: {
        bold: true,
        alignment: 'right',
        fillColor: '#d1d5db'
      }
    },

    content: [
      {
        columns: [
          {
            image: imageData,
            width: 60,
            alignment: 'left'
          },
          {
            text: 'RELATÓRIO DE CONTAS A RECEBER',
            style: 'titulo',
            alignment: 'center',
            width: '*'
          },
          {
            text: '',
            width: 60
          }
        ],
        margin: [0, 0, 0, 15],
        columnGap: 10
      },
      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
            lineColor: '#1f2937'
          }
        ],
        margin: [0, 0, 0, 10]
      },
      {
        columns: [
          { text: `Parceiro: ${parceiro}`, style: 'subInfo' },
          {
            text: `Total do Débito: ${total.toLocaleString('pt-BR', {
              minimumFractionDigits: 2
            })}`,
            alignment: 'right',
            style: 'subInfo'
          }
        ],
        margin: [0, 0, 0, 10]
      },
      {
        table: {
          headerRows: 1,
          widths: [50, 60, 60, '*', 50, 60, 70, 70],
          dontBreakRows: true,
          body: [
            [
              { text: 'Número', style: 'tableHeader' },
              { text: 'Emissão', style: 'tableHeader' },
              { text: 'Vencimento', style: 'tableHeader' },
              { text: 'Valor Parcela', style: 'tableHeader' },
              { text: 'Acrés.', style: 'tableHeader' },
              { text: 'Desconto', style: 'tableHeader' },
              { text: 'Valor Recebido', style: 'tableHeader' },
              { text: 'Valor Receber', style: 'tableHeader' }
            ],

            ...dados.map((item) => [
              { text: item.numero || '***', style: 'tableCell' },
              { text: moment(item.emissao).format('DD/MM/YYYY'), alignment: 'center', style: 'tableCell' },
              { text: moment(item.vencimento).format('DD/MM/YYYY'), alignment: 'center', style: 'tableCell' },
              { text: item.vparcela.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), alignment: 'right', style: 'tableCell' },
              { text: item.acrescimo.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), alignment: 'right', style: 'tableCell' },
              { text: item.desconto.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), alignment: 'right', style: 'tableCell' },
              { text: item.vrecebido.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), alignment: 'right', style: 'tableCell' },
              { text: item.vreceber.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), alignment: 'right', style: 'tableCell' }
            ]),

            [
              { text: '', colSpan: 5, border: [false, false, false, false] },
              {}, {}, {}, {},
              { text: Tdesconto.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), style: 'totalValue' },
              { text: Tpago.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), style: 'totalValue' },
              { text: Tpagar.toLocaleString('pt-BR', { minimumFractionDigits: 2 }), style: 'totalFinal' }
            ]
          ]
        },

        layout: {
          fillColor: function (rowIndex: number) {
            if (rowIndex === 0) return null;
            return rowIndex % 2 === 0 ? '#f9fafb' : null;
          },

          paddingTop: function () {
            return 6;
          },
          paddingBottom: function () {
            return 6;
          },

          hLineWidth: function (i: number) {
            return i === 1 ? 1 : 0.5;
          },
          vLineWidth: function () {
            return 0;
          },
          hLineColor: function () {
            return '#e5e7eb';
          }
        }
      },

      {
        text: `Gerado em ${moment().format('DD/MM/YYYY HH:mm')}`,
        alignment: 'right',
        fontSize: 8,
        margin: [0, 20, 0, 0],
        color: '#6b7280'
      }
    ]
  };

  pdfMake.createPdf(documentDefinition).open();
}
export default PDFReceber;
